import { createFileRoute } from '@tanstack/react-router';

import { requireTenantAdmin } from '@/features/tenants/utils/require-tenant-admin';
import { TenantSection } from '@/pages/tenant-section';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/tenant/$tenantId/users')({
  component: RouteComponent,
  beforeLoad: requireTenantAdmin,
});

function RouteComponent() {
  const { tenantId } = Route.useParams();

  return <TenantSection active="users" id={tenantId} />;
}
